import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCheckCircle, faTimesCircle } from '@fortawesome/pro-solid-svg-icons'

import { Text } from '@domain-group/suit-theme'

import type { UseArtworkPayload } from '@hooks/useArtwork'

interface ReviewStatusProps {
  artworkPayload: UseArtworkPayload,
}

const ReviewStatus = (props: ReviewStatusProps) => {
  const {
    artworkPayload: {
      allArtworkReviewsApproved,
      filteredArtworkReviews,
      hasFilteredArtworkReviews,
    },
  } = props

  const reviewCount = filteredArtworkReviews.length

  // No Reviews
  if (!hasFilteredArtworkReviews){
    return (
      <Text color="bodyFontLightColor" fontSize="xsmall" marginTop="medium">
        No Reviews Yet
      </Text>
    )
  }

  return (
    <Text color={allArtworkReviewsApproved ? 'green' : 'red'} fontSize="xsmall" marginTop="medium">
      <FontAwesomeIcon icon={allArtworkReviewsApproved ? faCheckCircle : faTimesCircle} />
      {' '}
      Reviewed by {reviewCount} {reviewCount === 1 ? 'User' : 'Users'}
    </Text>
  )
}

export default ReviewStatus
